import { useSelector } from 'react-redux';

import {
    getDateFormat,
    getShortDateFormat,
    getTimeZone,
    getUserDataPermissions,
    getUserId,
    getUserSettings,
} from './index';

export const useUserSettings = () => useSelector(getUserSettings);

export const useDateFormat = () => useSelector(getDateFormat);

export const useShortDateFormat = () => useSelector(getShortDateFormat);

export const useUserTimeZone = () => useSelector(getTimeZone);

export const useUserDataPermissions = () => useSelector(getUserDataPermissions);

export const useIserId = () => useSelector(getUserId);
